import { format } from 'date-fns';

export const getFilterDateParams = (startDate, endDate) => ({
	startDate: startDate && format(startDate, 'yyyy-MM-dd'),
	endDate: endDate && format(endDate, 'yyyy-MM-dd')
});
